import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PrivateRoute from "./privateRoute";
import models from "../model-declaration";
import Dashbaord from "../modules/dashboard";
import ListPage from "../modules/list";
import ViewPage from "../modules/read";
import Createpage from "../modules/create";
import Editpage from "../modules/edit";
import ProtectedRoute from "./protectedRoute";
import LoginPage from "../modules/auth/login";
import CreateUsers from "../modules/admin/users/create-users";
import ListUsers from "../modules/admin/users/list-users";
import ReadUsers from "../modules/admin/users/read-users";
import EditUsers from "../modules/admin/users/edit-users";
import TableList from "../modules/pos/table-list";
import TableDetails from "../modules/pos/table-details";
import AddTableProducts from "../modules/pos/add-table-products";
import EditTableProducts from "../modules/pos/edit-table-products";
import Checkout from "../modules/pos/checkout";
import ParcelTableProducts from "../modules/pos/parcel-table-products";
import PastOrderList from "../modules/pos/past-orders";
import PastOrderDetails from "../modules/pos/past-order-details";

const MainRoutes = () => {
  return (
    <Router>
      <Routes>
        <Route element={<PrivateRoute />}>
          <Route path="/dashboard" element={<TableList />} />
          {/* ------ AADMIN USERS ------ */}
          <Route path="/admin/users/list" element={<ListUsers />} />
          <Route path="/admin/users/create" element={<CreateUsers />} />
          <Route path="/admin/users/view/:id" element={<ReadUsers />} />
          <Route path="/admin/users/edit/:id" element={<EditUsers />} />
          <Route path="/pos/tables" element={<TableList />} />
          <Route path="/pos/table-details/:id" element={<TableDetails />} />
          <Route path="/pos/add-table-products/:id" element={<AddTableProducts />} />
          <Route path="/pos/edit-table-products/:id" element={<EditTableProducts />} />
          <Route path="/pos/checkout/:id" element={<Checkout />} />
          <Route path="/pos/parcel-add-items" element={<ParcelTableProducts />} />
          <Route path="/pos/past-orders" element={<PastOrderList />} />
          <Route path="/pos/past-order-details/:id" element={<PastOrderDetails />} />

          {models?.map((model) => (
            <React.Fragment>
              <Route
                path={`/${model.tableName}/list`}
                element={<ListPage model={model} />}
              />
              <Route
                path={`/${model.tableName}/view/:id`}
                element={<ViewPage model={model} />}
              />
              <Route
                path={`${model.tableName}/create`}
                element={<Createpage model={model} />}
              />
              <Route
                path={`${model.tableName}/edit/:id`}
                element={<Editpage model={model} />}
              />
            </React.Fragment>
          ))}
        </Route>
        <Route element={<ProtectedRoute />}>
          <Route path={`/`} element={<LoginPage />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default MainRoutes;
